import { useLazyQuery } from "@apollo/client";
import { GET_SITE_CHANNELS } from "../../graphql/queries";

const extractChannels = (data) => data?.siteChannels?.channels;

/**
 *  @deprecated Will be replaced by @see {@link useAllSiteChannels}.
 */
const useSiteChannels = ({ onCompleted, onError } = {}) => {

  const [getSiteChannelsQuery, { data, error, loading }] = useLazyQuery(
    GET_SITE_CHANNELS,
    {
      errorPolicy: "none",
      onCompleted: (data) => {
        const channels = extractChannels(data);
        console?.info("** Completed query: SiteChannels", { channels });
        onCompleted?.(channels);
      },
      onError: (error) => {
        console?.error("** Query error: SiteChannels", { error });
        onError?.(error);
      },
    }
  );

  const getSiteChannels = async (siteId = 0) => (
    await getSiteChannelsQuery({
      variables: {
        siteId,
      }
    })
  );

  return [
    getSiteChannels,
    {
      data: extractChannels(data),
      error,
      loading,
    }
  ];

};

export default useSiteChannels;
